// The browser should always use same-origin API paths.
// In local development, the frontend dev server proxies `/api` to the backend.
const API_BASE_URL = '';

export default API_BASE_URL;
